// extracted by mini-css-extract-plugin
module.exports = {"cls1":"_404-Article-module--cls1--2C32I","cls2":"_404-Article-module--cls2--2_Pnf _404-Article-module--cls1--2C32I"};